<template>

    <div>

      <section class="row">

        <header class="shop__header margin-b-50">

            <h1>Betalingen blev gennemført</h1>

            <p>Mange tak for din bestilling. Vi sender inden længe en ordrebekræftelse til dig pr. e-mail som indeholder
            din ordre. Du kan også downloade din ordrebekræftelse nedenfor som PDF.</p>

            <h3>Køb af Gavekort</h3>

            <p>Har du købt et gavekort er det også at finde i ordrebekræftelsen nedenfor og kan downloades som PDF.</p>

        </header>

        <section class="row margin-b-50 center">

          <a class="btn--primary" :href="invoiceLink" target="_blank">Download ordrebekræftelse</a>

        </section>

      </section>

    </div>

</template>

<script>
    import {mapGetters} from 'vuex';
    export default {
        data: function () {
            return {}
        },
        computed:{
            ...mapGetters({ invoice:'getInvoice', product:'getProduct', orderDetails:'getDetails', invoiceLink:'getInvoiceLink'}),
            pdf(){
                return '/invoice/download/' + this.invoice.uuid;
            }
        },
        methods: {
            totalWithTaxes(){
                var productTotal = this.orderDetails.product.quantity * this.orderDetails.product.price;
                var subProductsTotal = 0;

                if (this.orderDetails.subProducts.length > 0) {
                    subProductsTotal = this.orderDetails.subProducts.map(function (item, index) {
                        return item.quantity * item.price;
                    }).reduce(function (a, b) {
                        return a + b
                    }, 0);
                }

                return (productTotal + subProductsTotal) / 100;
            },
        },
        mounted(){
            this.$ua.trackView('Shop - Invoice');
             this.$analytics.fbq.event('Purchase', {
                 product: this.product.title,
                 currency: 'DKK',
                 value: this.totalWithTaxes(),
             });
        }
    }
</script>
